
import { mapActions } from 'vuex';
import { defineComponent } from '@nuxtjs/composition-api';
import PortfolioClientMixin from '@/components/partials/portfolio/PortfolioClientMixin/PortfolioClientMixin';
import type { Client, Company } from '@/types/graphql';
import PortfolioCurrentUserQuery from '@/apollo/queries/Portfolio/PortfolioCurrentUser.query';
import CompaniesAutocompleteV2 from '~/components/common/CompaniesAutocompleteV2/CompaniesAutocompleteV2.vue';
import PublicPortfolioEditClient from '~/components/partials/public-portfolio/PublicPortfolioClients/PublicPortfolioEditClient.vue';
import BravadoDraggableItems from '~/components/common/BravadoDraggableItems/BravadoDraggableItems.vue';
import SearchingGlassIcon from '~/assets/svg/searching-glass.vue.svg';
import { sortByField } from '~/components/utils/sorting_func';

export default defineComponent({
  name: 'ClientsForm',
  components: {
    CompaniesAutocompleteV2,
    PublicPortfolioEditClient,
    BravadoDraggableItems,
    SearchingGlassIcon,
  },
  extends: PortfolioClientMixin,
  apollo: {
    currentUser: {
      query: PortfolioCurrentUserQuery,
      update(data) {
        this.clients = data.currentUser?.solidClients.sort(sortByField('position'));
      },
    },
  },
  data() {
    return {
      clientQuery: '',
      clients: [],
    };
  },
  methods: {
    ...mapActions('portfolio', { fetchProfile: 'load' }),
    async onClientAdded(company: Company): Promise<void> {
      if (!company.id) return;

      await this.createClient(company.id);
      // @ts-ignore
      this.fetchProfile({ slug: this.$route.params.slug });
      this.$notice.success('Client successfully added');

      this.clientQuery = '';
      (this.$refs.clientList as HTMLElement).scrollTo({
        top: (this.$refs.clientList as HTMLElement).scrollHeight,
        behavior: 'smooth',
      });
    },
    async onClientPositionChange({ element, newPosition }: { element: Client; newPosition: number }): Promise<void> {
      await this.updateClientPosition({ id: element.id, position: newPosition });
      // @ts-ignore
      this.fetchProfile({ slug: this.$route.params.slug });
      this.$notice.success('Position successfully updated');
    },
    async onVisibilityChange(client: Client): Promise<void> {
      await this.updateClient({ id: client.id, isPublic: !client.isPublic });
      // @ts-ignore
      this.fetchProfile({ slug: this.$route.params.slug });
      this.$notice.success('Visibility successfully changed');
    },
    async onClientDelete(client: Client): Promise<void> {
      if (confirm('Are you sure?')) {
        await this.destroyClient(client.id);
        // @ts-ignore
        this.fetchProfile({ slug: this.$route.params.slug });
        this.$notice.success('Client successfully deleted');
      }
    },
  },
});
